export const infoCard = {
	seeDatails: "Ver detalhes",
};
